<template>
    <div class="printOrderListBox">
        <el-tabs v-model="activeName" class="orderListTabs">
            <el-tab-pane v-for="item in tabList" :key="item.id" :label="item.name" :name="item.id">
            </el-tab-pane>
        </el-tabs>
        <div>
            <div class="orderSearchBox">

                <el-input v-model="keywords" placeholder="关键字"></el-input>
                <el-button class="searchBtn" @click="getList">搜索</el-button>
            </div>
            <div class="orderListTable">
                <div class="tableTool">
                    <div class="toolLeft">
                        <span>已选： <span class="num">{{multipleSelection.length}}</span></span>
                        <el-button type="primary" plain size="small" @click="deleteInfoBySelect" :disabled="multipleSelection.length<=0">批量删除</el-button>
                        <el-button type="primary" plain size="small" @click="updateStationMessageStatusById" :disabled="multipleSelection.length<=0">标记已读</el-button>
                        <el-button type="primary" plain size="small" @click="updateStationMessageStatusAll" >全部已读</el-button>
                    </div>
                </div>
                <ul class="tableHeader">
                    <li class="select">
                        <el-checkbox v-model="checkedAll"  @change="tableHeaderChange">全选</el-checkbox>
                    </li>
                </ul>
                <ul class="tableBody" v-if="tableList.length != 0" v-loading="loading" >
                    <li class="bodyItem" v-for="item in tableList">
                        <div class="itemTop">
                            <el-checkbox v-model="item.checked" style="padding-right: 20px;"  @change="bodyItemCheckChange"></el-checkbox>
                            <div>创建时间：{{item.createDate}}</div>
                            <div>{{item.msgStatus==='UNREAD'?'未读':'已读'}}</div>
                            <el-button type="text" @click="deleteInfo(item.uuid)">删除</el-button>
                        </div>
                        <div class="itemBottom">
                            <div class="name">
                                <div class="orderInfo">
                                    <div class="infoName">{{item.msgContent}}</div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div> -->
                <div class="orderNomesaage" v-loading="loading" v-else >
                     <img src="../../../assets/images/暂无内容.jpg" alt="" style="width:200px">
                </div>
            </div>

            <el-pagination
                v-if="tableList.length != 0"
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="pageNo"
                :page-size="pageSize"
                :total="total" class="pagination">
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import {getStationMessageLogList,updateStationMessageStatusById,updateStationMessageStatusAll,deleteStationMessageLog} from "../../../utils/stationMessageLog"

    export default {
        name: "stationMessageLog",
        data(){
            return{
                form: {},
                activeName: '0',
                tabList: [
                    {
                        id: '0',
                        name: '我的消息'
                    }
                ],
                checkedAll: false,
                loading: false,
                tableList: [],
                pageNo: 1,
                total: 0,
                pageSize: 8,
                multipleSelection: [],
                keywords: ''
            }
        },
        created() {
            this.getList()
        },
        methods: {
            getList(){
                this.rest();
                this.loading = true
                this.form.keywords  = this.keywords;
                getStationMessageLogList(this.form).then((res)=>{
                    if(res.data != null){
                        this.tableList = res.data;
                        this.loading = false
                        this.pageSize=res.pageSize;
                        this.total=res.total;
                        this.pageNo =res.current;
                    }else {
                        this.loading = false
                    }
                });
            },
            handleCurrentChange(val){
                this.pageNo = val
                this.getList()
            },
            rest(){
                this.multipleSelection=[];
                this.checkedAll=false;
            },
            deleteInfo(uuid){
                this.loading = true

                this.$confirm('确定删除数据吗?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let params = {ids:uuid};
                    deleteStationMessageLog(params).then((res) => {
                        if (res.success) {
                            this.$message.success("删除成功");
                            this.getList()
                        }
                    });
                }).catch(() => {
                    this.loading = false
                });
            },
            deleteInfoBySelect(){
                let ids=[];
                this.multipleSelection.map(item => {
                    ids.push(item.uuid)
                })
                let params = {ids: ids.join(',')};
                console.log(params)
                this.$confirm('确定删除选中数据吗?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    deleteStationMessageLog(params).then((res) => {
                        if (res.success) {
                            this.$message.success("删除成功");
                            this.getList()
                        }
                    });
                }).catch(() => {});
            },
            updateStationMessageStatusById(){
                let ids=[];
                this.multipleSelection.map(item => {
                    ids.push(item.uuid)
                })
                let params = {ids: ids.join(',')};
                this.$confirm('确定选中数据标记为已读吗?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    updateStationMessageStatusById(params).then((res) => {
                        if (res.success) {
                            this.$message.success("成功");
                            this.getList()
                        }
                    });
                }).catch(() => {});
            },
            updateStationMessageStatusAll(){
                this.$confirm('确定全部数据标记为已读吗?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    updateStationMessageStatusAll().then((res) => {
                    if (res.success) {
                        this.$message.success("成功");
                        this.getList()
                    }
                });
                }).catch(() => {});
            },
            // 列表选择功能
            tableHeaderChange(val){
                this.tableList.map(item=>{
                    item.checked = val
                })
                if(val){
                    this.multipleSelection = this.tableList
                } else {
                    this.multipleSelection = []
                }
            },
            bodyItemCheckChange(){
                this.multipleSelection = this.tableList.filter(res => res.checked === true)
                if(this.multipleSelection.length === this.tableList.length){
                    this.checkedAll = true
                } else {
                    this.checkedAll = false
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .printOrderListBox {
        padding: 94px 20px 20px;
        .orderListTabs{
            position: absolute;
            left: 0;
            top: 0;
            z-index: 999;
            background: #fff;
            width: 100%;
            padding: 20px;
        }
        /deep/ .el-tabs__item {
            padding: 0 25px !important;
            text-align: center;

            &:hover {
                color: #3686d7
            }

            &:after {
                content: "";
                position: absolute;
                right: 0;
                bottom: 12px;
                width: 1px;
                height: 15px;
                background-color: #E4E7ED;
                z-index: 1;
            }

            &:last-child:after {
                content: "";
                width: 0;
                height: 0;
            }
        }
        /deep/ .el-tabs__active-bar {
            height: 3px;
            background-color: #3686d7;
        }
        /deep/ .el-tabs__item.is-active {
            color: #3686d7
        }
        /deep/ .el-tabs__nav-wrap::after {
            height: 1px;
        }
        .orderSearchBox {
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                margin-bottom:22px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom:22px;
            }
        }
        .orderListTable {
            .orderNomesaage {
                color: #888;
                text-align: center;
                padding: 15px 0;
            }
            .tableTool {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;

                .toolLeft {
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.847);

                    .num {
                        color: #356FDF;
                    }

                    button {
                        padding: 0;
                        margin-left: 15px;
                        width: 80px;
                        height: 30px;
                        background: rgba(242, 244, 247, 1);
                        box-sizing: border-box;
                        border: 1px solid rgba(21, 126, 251, 1);
                        border-radius: 5px;
                        font-size: 12px;
                        color: #157EFB;
                        line-height: 30px;
                        text-align: center;

                        &:hover {
                            background: #157EFB;
                            box-sizing: border-box;
                            border: 1px solid #157EFB;
                            color: #fff;
                        }
                    }
                }

                .toolRight {
                    button {
                        width: 83px;
                        height: 30px;
                        background: rgba(21, 126, 251, 1);
                        border: none;
                        border-radius: 15px;
                        font-size: 13px;
                        color: #fff;

                        i {
                            padding-right: 5px;
                        }

                        &:hover {
                            background: #61a2f0;
                        }
                    }
                }
            }
            .tableHeader {
                display: flex;
                width: 100%;
                height: 35px;
                line-height: 35px;
                background: #f3f7ff;
                border-radius: 5px;
                margin: 0 0 15px;

                li {
                    text-align: center;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                }
            }
            .select{
                padding: 0 20px;
            }
            .tableBody {
                li {
                    width: 100%;
                    border: 1px solid #f2f2f2;
                    border-radius: 10px;

                    .itemTop {
                        width: 100%;
                        height: 42px;
                        background: #ebf3fb;
                        line-height: 42px;
                        font-size: 14px;
                        color: #333;
                        padding: 0 20px;
                        display: flex;
                        align-items: center;
                        position: relative;

                        div {
                            margin-right: 30px;
                        }

                        .merchantInfo {
                            display: flex;
                            align-items: center;

                            i {
                                color: #3d7fff;
                                font-size: 25px;
                                cursor: pointer;
                                padding-left: 5px;
                                display: block;
                            }

                            img {
                                display: block;
                                padding-right: 5px;
                            }
                        }

                        .complainBtn {
                            color: #999;
                            position: absolute;
                            right: 20px;
                        }
                    }

                    .itemBottom {
                        display: flex;
                        align-items: center;
                        color: #333;
                        font-size: 13px;

                        .orderInfo {
                            padding: 20px;
                            display: flex;

                            img {
                                display: block;
                                width: 100px;
                                height: 100px;
                                border-radius: 10px;
                                margin-right: 30px;
                            }

                            .infoContent {
                                .infoName {
                                    font-size: 14px;
                                    color: #000000;
                                    padding-bottom: 10px;
                                }

                                .infoOther {
                                    font-size: 13px;
                                    color: #999999;
                                    padding-bottom: 8px;
                                }
                            }
                        }

                        .arguments {
                            padding: 20px;
                        }

                        .argumentsName {
                            padding-bottom: 8px;
                        }
                        .payment {
                            h3 {
                                font-size: 14px;
                                font-weight: 700;
                                margin: 0;
                            }

                            .title {
                                font-size: 12px;
                                color: #999999;
                            }
                        }
                        .status{
                            font-size: 14px;
                        }
                        .operationBtn{
                            display: block;
                            color: #0C75D3;
                            text-align: center;
                            width: 100%;
                            margin: 0;
                        }
                    }
                }
            }

            .name {
                flex: 1;
                position: relative;
            }

            .price {
                width: 120px;
                text-align: center;
            }

            .num {
                width: 95px;
                text-align: center;
            }

            .arguments {
                width: 294px;
            }

            .payment {
                width: 162px;
                text-align: center;
            }

            .status {
                width: 124px;
                text-align: center;
            }

            .operation {
                width: 145px;
                text-align: center;
                .operationUploadBtn{
                    width: 102px !important;
                    height: 34px;
                    padding: 0;
                    line-height: 34px;
                    text-align: center;
                    font-weight: 700;
                    color: rgba(0, 102, 204, 0.8);
                    font-size: 14px;
                    border-color: rgba(0, 102, 204, 0.8);
                    display: block;
                    margin: 0 auto 10px !important;
                }
            }
        }
        .preview{
            position: absolute;
            width: 85px;
            height: 25px;
            padding: 0;
            text-align: center;
            border: none;
            left: 28px;
            bottom: 33px;
            background: rgba(255,255,255,.6);
            font-size: 12px;
            color: #1296DB;
            font-weight: 700;
        }
        .submitButtonGroup{
            /deep/.el-form-item__content{
                text-align: center;
                margin-left: 0 !important;
                button{
                    padding: 0;
                    width: 120px;
                    height: 35px;
                    line-height: 35px;
                    text-align: center;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/stationMessageLog/stationMessageLog.vue